var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./nav_controls.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5eb08234\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./nav_controls.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./pipelines/components/nav_controls.vue
// module id = ./pipelines/components/nav_controls.vue
// module chunks = pipelines